import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import PictureAsPdfOutlinedIcon from "@material-ui/icons/PictureAsPdfOutlined";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";
import { Trad } from "../../components";
import * as Glob from "../../Globale";
import { GetUserImg } from "../helpers/Common";
import bg from "../images/user_profile_bg.jpg";

const useStyles = makeStyles(theme => ({
    icon: {
        width: "30px",
        height: "30px"
    },
    avatar: {
        width: "50px",
        height: "50px"
    },
    menuCard: {
        width: 260
    },
    menuCardTitle: {
        color: theme.palette.common.white
    }
}));

export const _UserMenu = () => {
    const classes = useStyles();
    const session = Glob.GetSessione();
    const avatarUrl = GetUserImg(session.Immagine);
    const popupState = usePopupState({ variant: "popover", popupId: "userMenu" });

    return (
        <>
            <IconButton edge="start" color="inherit" aria-label="user" {...bindTrigger(popupState)}>
                <Avatar src={avatarUrl} className={classes.icon} />
            </IconButton>
            <Popover
                {...bindMenu(popupState)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                TransitionComponent={Collapse}
            >
                <Card className={classes.menuCard}>
                    <CardMedia className={classes.menuCardTitle} component="div" image={bg}>
                        <CardHeader
                            avatar={<Avatar src={avatarUrl} className={classes.avatar} />}
                            title={`${session.Nome} ${session.Cognome}`}
                            subheader={session.Email}
                            titleTypographyProps={{ variant: "h6" }}
                            subheaderTypographyProps={{ color: "secondary" }}
                        />
                    </CardMedia>
                    <CardContent onClick={popupState.close}>
                        <List dense disablePadding>
                            <ListItem button component="a" href={`/Utente/${session.ID_Utente || ""}`}>
                                <ListItemIcon>
                                    <PersonOutlineOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText primary={Trad.Trad("Profilo utente")} />
                            </ListItem>
                            <ListItem button component="a" href="/File/Manuale.pdf">
                                <ListItemIcon>
                                    <PictureAsPdfOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText primary={Trad.Trad("Manuale utente")} />
                            </ListItem>
                            <ListItem button component="a" href="/logout">
                                <ListItemIcon>
                                    <LockOpenOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText primary={Trad.Trad("Logout")} />
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            </Popover>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/UserMenu.tsx